import React, { PropsWithChildren, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import ResetIcon from 'client/components/core/Sidebar/components/Settings/styles/ui/ResetIcon'
import { Tooltip } from 'client/components/core/tooltip'
import Item from './Item'
import Label from './Label'
import Value from './Value'

export interface OptionWrapperProps {
  labelText?: string
  resetText?: string
  directionRow?: boolean
  isResetIconVisible?: boolean
  labelIcon?: ReactNode
  helpMessage?: string
  needTranslate?: boolean
  itemStyles?: React.CSSProperties
  width?: number
  fullWidth?: boolean
  onReset?: () => void
}

const OptionWrapper = ({
  labelText,
  labelIcon,
  isResetIconVisible = false,
  resetText = '',
  directionRow = false,
  children,
  helpMessage = '',
  needTranslate = true,
  itemStyles = {},
  width,
  onReset,
}: PropsWithChildren<OptionWrapperProps>) => {
  const { t } = useTranslation()

  return (
    <Item itemStyle={itemStyles} width={width} directionRow={directionRow}>
      {labelText && (
        <Label directionRow={directionRow}>
          {labelText && helpMessage ? (
            <Tooltip message={needTranslate ? t(helpMessage) : helpMessage}>
              {needTranslate ? t(labelText) : labelText}
            </Tooltip>
          ) : needTranslate ? (
            t(labelText)
          ) : (
            labelText
          )}
          {labelIcon}
          {isResetIconVisible && (
            <ResetIcon onClick={onReset} title={t(resetText)} />
          )}
        </Label>
      )}

      <Value directionRow={directionRow}>{children}</Value>
    </Item>
  )
}

export { OptionWrapper as default, Value, Label, Item }
